export enum EventType {
    OPEN_CART = 'openCart',
    UPDATE_CART = 'updateCart',
    CLEAR_CART = 'clearCart',
}
